module.exports = {
          srcSet: __webpack_public_path__ + "3188e20b.png"+" 700w"+","+__webpack_public_path__ + "495b779c.png"+" 1024w",
          images:[ {path: __webpack_public_path__ + "3188e20b.png",width: 700,height: 525},{path: __webpack_public_path__ + "495b779c.png",width: 1024,height: 768}],
          src: __webpack_public_path__ + "3188e20b.png",
          toString:function(){return __webpack_public_path__ + "3188e20b.png"},
          
          width: 700,
          height: 525
        }